import { createSlice } from '@reduxjs/toolkit';
import { ENUM__redux_slice } from '../../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../../_base/LOCAL__global_reset';
import { init_local_admin_users_online_upsert } from './local_admin_users_online_upsert';
import { StateAdminUsers } from './state_admin_users';

const initialState: StateAdminUsers = {
  users_online: 0,
};

export const slice_admin_users = createSlice({
  name: ENUM__redux_slice.ADMIN_USERS,
  initialState,
  reducers: {
    online_upsert: init_local_admin_users_online_upsert,
  },
  extraReducers: builder => {
    builder.addCase(LOCAL__global_reset, state => {
      return initialState;
    });
  },
});
